import { useEffect, useState } from 'react';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { mypageData } from '../../components/Tab/TabData';

import Pagination from 'react-js-pagination';
import useScreenSize from '../../hooks/useScreenSize';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { fetchGet } from '../../hooks/fetch';
import { DownloadLink } from '../../utils/DownloadFunctions';
import Loading from '../Loading';

export default function MyInquiry() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '내 문의';
	const [posts, setPosts] = useState([]); // 전체 게시글 데이터

	const [page, setPage] = useState(1); // 현재 페이지 번호
	const [pagingInfo, setPagingInfo] = useState({ totalCount: 0, totalPage: 0 });
	
	const postPerPage = 10; // 페이지 당 게시글 갯수

	const handlePageChange = (page) => {
		setPage(page);
	};

	const screenSize = useScreenSize();

	function getPage() {
		fetchGet(
			`/mypage/inquiry`,
			(json) => {
				setPosts(json.dataList);
				setPagingInfo(json.pagingInfo);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, [page]);

	return (
		<main id="mypage-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={mypageData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<Accordion
							className="gs-accordion-con inquiry-accordion"
							transition
							transitionTimeout={200}
							allowMultiple
						>
							{isLoading ? <Loading /> : posts?.map((post, i) => (
								<AccordionItem
									key={i}
									header={
										<>
											{post?.answeredYn === 'N' ? (
												<div className="state">[답변 대기]</div>
											) : (
												<div className="state completed">[답변 완료]</div>
											)}
											<div className="con">{post.title}</div>
											<div className="date">
												<span>{post.inquiryDate}</span>
											</div>
										</>
									}
								>
									<>
										<div className="inquiry-q">
											<div dangerouslySetInnerHTML={{ __html: post?.content }} />
											{post.files !== null && (
												<ul className="gs-files">
													{post.files?.map((f) => <li key={f.uid}><DownloadLink name={f.name} uid={f.uid} /></li>)}
												</ul>
											)}
										</div>
										{post.answeredYn === 'Y' && (
											<div className="inquiry-a">
												<div className="top">
													<div>[답변 내용]</div>
													<div className="date">
														<span>{post.answerDate}</span>
													</div>
												</div>
												<div dangerouslySetInnerHTML={{ __html: post?.answer }} />
											</div>
										)}
									</>
								</AccordionItem>
							))}
						</Accordion>

						{pagingInfo.totalCount > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={postPerPage} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
			</Container>
		</main>
	);
}
